<!--  -->
<template>
  <div class='privacy' v-html="nodes"></div>
</template>

<script>

export default {
  components: {},
  data() {
    return {
      nodes: null
    };
  },
  props: {
    type: {
      type: String | Number,
      default: '7'
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
    this.API.post("Home/article_out-get_protocol", {protocol_type: this.type}).then((res) => {
      if (res.errno == 0) {
        this.nodes = res.data.protocol_info
      } else {
        this.$message.error(res.message || '请求失败!')
      }
    });
  },
  //方法集合
  methods: {
    
  },
}
</script>

<style lang='less' scoped>
.privacy {
  padding: 20px;
}
</style>